import {
  SettingOutlined,
  ToolOutlined,
  DatabaseOutlined,
  DashboardOutlined,
  LineChartOutlined,
  AppstoreOutlined,
  ShoppingCartOutlined,
  QuestionCircleOutlined,
  DesktopOutlined,
  FileAddOutlined,
  SlidersOutlined,
  TableOutlined,
  UserOutlined,
  BankOutlined,
  MobileOutlined,
  SendOutlined,
  TeamOutlined,
  RocketOutlined,
  WhatsAppOutlined,
  RobotOutlined,
  FileTextOutlined,
  HistoryOutlined,
  NotificationOutlined,
  VideoCameraOutlined,
  AuditOutlined,
  FilePdfOutlined,
  ReconciliationOutlined,
  IdcardOutlined,
  ShopOutlined,
  UsergroupAddOutlined,
  FileDoneOutlined,
  UndoOutlined,
  BookOutlined,
  FolderViewOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const waBuddyNavTree = [
  {
    key: "wa-buddy",
    scope: ["wa-buddy"],
    featured: true,
    path: `${APP_PREFIX_PATH}`,
    title: "sidenav.wa-buddy",
    icon: DatabaseOutlined,
    breadcrumb: false,
    submenu: [
      {
        scope: ["wa-buddy"],
        key: "wa-buddy-dashboard",
        path: `${APP_PREFIX_PATH}/dashboard`,
        title: "sidenav.wa-buddy-dashboard",
        icon: DashboardOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        scope: ["wa-buddy"],
        key: "wa-buddy-launches",
        path: `${APP_PREFIX_PATH}/launches`,
        title: "sidenav.wa-buddy-launches",
        allowed_paths: [
          { path: `${APP_PREFIX_PATH}/launches/list`, title: "sidenav.wa-buddy-launches-list" },
          { path: `${APP_PREFIX_PATH}/launches/manage/.*`, title: "sidenav.wa-buddy-launches-manage" },
        ],
        icon: RocketOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        scope: ["wa-buddy"],
        key: "wa-buddy-groups",
        path: `${APP_PREFIX_PATH}/groups`,
        title: "sidenav.wa-buddy-groups",
        allowed_paths: [
          { path: `${APP_PREFIX_PATH}/groups/list`, title: "sidenav.wa-buddy-groups-list" },
          { path: `${APP_PREFIX_PATH}/groups/manage/.*`, title: "sidenav.wa-buddy-groups-manage" },
        ],
        icon: WhatsAppOutlined,
        breadcrumb: true,
        submenu: [],
      },

      {
        scope: ["wa-buddy"],
        key: "wa-buddy-help",
        path: `${APP_PREFIX_PATH}/wa-buddy-help`,
        title: "sidenav.wa-buddy-help",

        icon: QuestionCircleOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
];

const defaultNavTree = [
  {
    key: "salespark",
    scope: ["base"],
    //featured: true,
    path: `${APP_PREFIX_PATH}`,
    title: "sidenav.dashboard",
    icon: DatabaseOutlined,
    breadcrumb: false,
    submenu: [
      {
        scope: ["salespark"],
        key: "salespark-global",
        path: `${APP_PREFIX_PATH}/dashboard`,
        title: "Dashboard",
        description: "Painel inicial com informações base sobre a tua conta.",
        tags: ["dashboard", "global", "inicial", "informações", "conta", "saldo"],
        icon: DashboardOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        scope: ["salespark"],
        //featured: true,
        key: "salespark-onboarding",
        path: `${APP_PREFIX_PATH}/onboarding`,
        title: "Onboarding",
        description: "Aqui podes encontrar videos e tutoriais para te ajudar a começar a usar a SalesPark.",
        tags: ["onboarding", "tutorial", "video", "ajuda", "começar"],
        icon: VideoCameraOutlined,
        breadcrumb: true,
        submenu: [],
      },
      // {
      //   scope: ["salespark"],
      //   key: "salespark-sales",
      //   path: `${APP_PREFIX_PATH}/sales-dashboard`,
      //   title: "sidenav.dashboard-sales",
      //   icon: EuroCircleOutlined,
      //   breadcrumb: true,
      //   submenu: [],
      // },

      // Products
      {
        scope: ["salespark"],
        key: "salespark-products",
        path: `${APP_PREFIX_PATH}/products`,
        title: "Produtos",
        icon: AppstoreOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "salespark-products-new",
            path: `${APP_PREFIX_PATH}/products/new`,
            title: "Criar Produto",
            description: "Cria um novo produto para vender na SalesPark.",
            tags: [
              "criar",
              "novo",
              "produto",
              "vender",
              "curso",
              "book",
              "audio",
              "serviço",
              "digital",
              "evento",
              "evento online",
              "evento presencial",
              "sessão",
              "consultoria",
              "consulta",
              "masterclass",
              "mentoria",
              "workshop",
              "bundle",
              "sessão",
              "reunião",
              "conferência",
            ],
            icon: FileAddOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "salespark-products-list",
            path: `${APP_PREFIX_PATH}/products/list`,
            allowed_paths: [
              { path: `${APP_PREFIX_PATH}/products/edit/.*`, title: "sidenav.products_edit" },
              { path: `${APP_PREFIX_PATH}/products/view/.*`, title: "sidenav.products_view" },
            ],
            title: "Lista de Produtos",
            description: "Lista de todos os produtos que tens disponíveis para venda na SalesPark.",
            tags: ["lista", "produtos", "venda", "co-produtor", "afiliado", "afiliação", "coprodutor", "vender", "links", "pagamento", "divulgar"],
            icon: TableOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "salespark-products-affiliate-market",
            path: `${APP_PREFIX_PATH}/products/affiliate-market`,
            title: "Mercado de Afiliação",
            description: "Lista de produtos disponíveis para afiliação.",
            tags: ["afiliados", "afiliação", "produtos", "venda", "divulgar", "comissão", "ganhar"],
            icon: ShopOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },

      // Orders
      {
        key: "salespark-orders",
        scope: ["salespark"],
        path: `${APP_PREFIX_PATH}/orders`,
        //  allowed_paths: [{ path: `${APP_PREFIX_PATH}/orders/overview`, title: "sidenav.orders_overview" }],
        title: "Vendas",
        icon: ShoppingCartOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "salespark-orders-overview",
            path: `${APP_PREFIX_PATH}/orders/overview`,
            allowed_paths: [{ path: `${APP_PREFIX_PATH}/orders/overview`, title: "sidenav.orders_overview" }],
            title: "Visão Geral Vendas",
            description: "Visão geral das vendas feitas e pre-checkouts.",
            tags: ["venda", "pago", "pendente", "pre-checkouts", "visão", "geral", "overview", "compra", "lista", "pagamento"],
            icon: SlidersOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "salespark-orders-buyers",
            scope: ["salespark"],
            path: `${APP_PREFIX_PATH}/buyers`,
            allowed_paths: [
              { path: `${APP_PREFIX_PATH}/buyers/list`, title: "sidenav.buyers_list" },
              { path: `${APP_PREFIX_PATH}/buyers/view-details/.*`, title: "sidenav.buyers_view_details" },
            ],
            title: "Compradores",
            description: "Lista de compradores que já fizeram compras na SalesPark.",
            tags: ["comprador", "compra", "lista", "detalhes", "comprador", "venda", "cliente"],
            icon: UserOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "salespark-orders-subscriptions",
            path: `${APP_PREFIX_PATH}/orders/subscriptions`,
            title: "Recorrências",
            description: "Lista de subscrições / Recorrências na SalesPark.",
            tags: ["subscrição", "recorrência", "pagamento", "mensal", "anual", "renovação", "assinatura"],
            icon: BankOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "salespark-orders-refunds",
            path: `${APP_PREFIX_PATH}/orders/refunds`,
            title: "Reembolsos",
            description: "Lista de reembolsos na SalesPark.",
            tags: ["reembolso", "devolução", "pedido reembolso", "compra", "venda"],
            icon: UndoOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },

      // Courses
      {
        key: "salespark-courses",
        scope: ["salespark"],
        path: `${APP_PREFIX_PATH}/courses`,

        allowed_paths: [
          { path: `${APP_PREFIX_PATH}/courses/manage/(.*)/curriculum`, title: "sidenav.courses_edit" },
          {
            path: `${APP_PREFIX_PATH}/courses/manage/(.*)/curriculum/chapter/(.*)`,
            title: "sidenav.courses_chapter_edit",
          },
          {
            path: `${APP_PREFIX_PATH}/courses/manage/(.*)/curriculum/chapter/(.*)/lesson/(.*)`,
            title: "sidenav.courses_chapter_lesson_edit",
          },
          { path: `${APP_PREFIX_PATH}/courses/manage/(.*)/dashboard`, title: "sidenav.courses_dashboard" },
          { path: `${APP_PREFIX_PATH}/courses/manage/(.*)/settings`, title: "sidenav.courses_settings" },
          { path: `${APP_PREFIX_PATH}/courses/manage/(.*)/statistics`, title: "sidenav.courses_statistics" },
          { path: `${APP_PREFIX_PATH}/courses/manage/(.*)/classes`, title: "sidenav.courses_classes" },
          { path: `${APP_PREFIX_PATH}/courses/manage-v2/(.*)/curriculum`, title: "sidenav.courses_edit" },
          { path: `${APP_PREFIX_PATH}/courses/manage-v2/(.*)/dashboard`, title: "sidenav.courses_dashboard" },
          { path: `${APP_PREFIX_PATH}/courses/manage-v2/(.*)/settings`, title: "sidenav.courses_settings" },
          { path: `${APP_PREFIX_PATH}/courses/manage-v2/(.*)/statistics`, title: "sidenav.courses_statistics" },
          { path: `${APP_PREFIX_PATH}/courses/manage-v2/(.*)/classes`, title: "sidenav.courses_classes" },
          { path: `${APP_PREFIX_PATH}/courses/view/.*`, title: "sidenav.courses_view" },
        ],
        title: "Cursos",
        icon: DesktopOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "salespark-courses-new",
            scope: ["salespark"],
            path: `${APP_PREFIX_PATH}/courses/new`,
            title: "Novo Curso",
            description: "Cria um novo curso para vender na SalesPark.",
            tags: ["curso", "aula", "módulo", "audio", "video", "aluno"],
            icon: FileAddOutlined,
            breadcrumb: true,
            submenu: [],
          },

          {
            key: "salespark-courses-list",
            scope: ["salespark"],
            path: `${APP_PREFIX_PATH}/courses/list`,
            title: "Lista de Cursos",
            description: "Lista dos cursos que tens disponíveis para venda na SalesPark.",
            tags: ["curso", "aula", "módulo", "audio", "video", "aluno"],
            icon: FolderViewOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "salespark-courses-comments-manager",
            showNumIncompletedComments: true,
            scope: ["salespark"],
            path: `${APP_PREFIX_PATH}/courses/comments-manager`,
            title: "Comentários",
            description: "Gestão de comentários feitos nas aulas dos cursos.",
            tags: ["comentário", "aulas", "curso", "gestão", "moderação"],
            icon: AuditOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "salespark-courses-library",
            scope: ["salespark"],
            path: `${APP_PREFIX_PATH}/courses/library`,
            title: "Biblioteca de vídeos",
            description: "Biblioteca de videos para uso nas aulas dos cursos.",
            tags: ["biblioteca", "video", "libraria"],
            icon: VideoCameraOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },

   
      // Students
      {
        key: "salespark-students",
        scope: ["salespark"],
        path: `${APP_PREFIX_PATH}/students`,
        allowed_paths: [
          { path: `${APP_PREFIX_PATH}/students/list`, title: "sidenav.students_list" },
          { path: `${APP_PREFIX_PATH}/students/details/.*`, title: "sidenav.students_details" },
        ],
        title: "Alunos",
        description: "Lista e Gestão de alunos que já compraram cursos na SalesPark.",
        tags: ["aluno", "estudante", "curso", "aula", "módulo", "audio", "video", "comprador"],
        icon: TeamOutlined,
        breadcrumb: true,
        submenu: [],
      },

      // Reports
      {
        key: "salespark-reports",
        scope: ["salespark"],
        path: `${APP_PREFIX_PATH}/reports`,
        title: "Relatórios",
        icon: LineChartOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "salespark-reports-transactions",
            path: `${APP_PREFIX_PATH}/reports/transactions`,
            title: "Transações",
            description: "Relatório de transações (vendas, comissões, reembolsos, etc).",
            tags: ["relatório", "transação", "transações", "venda", "comissão", "comissões", "reembolso", "pagamento", "recebimento"],
            icon: SlidersOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "salespark-reports-documents",
            path: `${APP_PREFIX_PATH}/reports/documents`,
            title: "Documentos Fiscais",
            description: "Lista de documentos fiscais (faturas, recibos, etc).",
            tags: ["documento", "fiscal", "fatura", "recibo", "documento", "comprovativo", "pagamento"],
            icon: FilePdfOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
      {
        key: "salespark-management",
        scope: ["salespark"],
        path: `${APP_PREFIX_PATH}/management`,
        //  allowed_paths: [{ path: `${APP_PREFIX_PATH}/orders/overview`, title: "sidenav.orders_overview" }],
        title: "Gestão",
        icon: SettingOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "salespark-management-services",
            path: `${APP_PREFIX_PATH}/management/services`,
            title: "Serviços",
            description: "Gestão dos serviços vendidos na SalesPark.",
            tags: ["serviço", "venda", "gestão", "gerir", "reembolso"],
            icon: ReconciliationOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "salespark-management-attendees",
            path: `${APP_PREFIX_PATH}/management/attendees`,
            title: "Participantes (Eventos)",
            description: "Gestão dos participantes de eventos (online e precenciais).",
            tags: ["evento", "participante", "presença", "online", "presencial", "evento", "conferência"],
            icon: IdcardOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "salespark-management-affiliates",
            path: `${APP_PREFIX_PATH}/management/affiliates`,
            title: "Afiliados (Afiliação)",
            description: "Gestão dos afiliados da SalesPark.",
            tags: ["afiliado", "afiliação", "comissão", "promover"],
            icon: UsergroupAddOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "salespark-management-affiliates-invoices",
            path: `${APP_PREFIX_PATH}/management/affiliates-invoices`,
            title: "Faturas dos Afiliados",
            description: "Gestão de faturas de afiliados da SalesPark.",
            tags: ["afiliado", "afiliação", "fatura"],
            icon: FileDoneOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },

         // Questionnaires
         {
          key: "salespark-questionnaires",
          scope: ["salespark"],
          path: `${APP_PREFIX_PATH}/questionnaires`,
          title: "Questionários",
          icon: BookOutlined,
          breadcrumb: true,
          allowed_paths: [
            { path: `${APP_PREFIX_PATH}/questionnaires/list`, title: "Lista de Questionários" },
            { path: `${APP_PREFIX_PATH}/questionnaires/manage/.*`, title: "Gestão de Questionário" },
            { path: `${APP_PREFIX_PATH}/questionnaires/answers`, title: "Respostas" },
          ],
          submenu: [
            {
              key: "salespark-questionnaires-list",
              scope: ["salespark"],
              path: `${APP_PREFIX_PATH}/questionnaires/list`,
              title: "Lista de Questionários",
              description: "Lista de questionários disponíveis para os teus cursos.",
              tags: ["questionário", "curso", "lista", "perguntas"],
              icon: FolderViewOutlined,
              breadcrumb: true,
              submenu: [],
            },
            {
              key: "salespark-questionnaires-answers",
              scope: ["salespark"],
              path: `${APP_PREFIX_PATH}/questionnaires/answers`,
              title: "Respostas",
              description: "Consulta e gestão das respostas submetidas pelos alunos.",
              tags: ["questionário", "resposta", "aluno", "curso"],
              icon: TableOutlined,
              breadcrumb: true,
              submenu: [],
            },
          ],
        },
  

      // Work Tools
      {
        key: "salespark-work-tools",
        scope: ["salespark"],
        path: `${APP_PREFIX_PATH}/work-tools`,
        allowed_paths: [
          { path: `${APP_PREFIX_PATH}/work-tools/list`, title: "sidenav.work_tools-list" },
          { path: `${APP_PREFIX_PATH}/work-tools/meta-pixel`, title: "sidenav.work_tools-meta-pixel" },
          { path: `${APP_PREFIX_PATH}/work-tools/ga4-pixel`, title: "sidenav.work_tools-ga4-pixel" },
          { path: `${APP_PREFIX_PATH}/work-tools/gtm-pixel`, title: "sidenav.work_tools-gtm-pixel" },
          { path: `${APP_PREFIX_PATH}/work-tools/webhooks`, title: "sidenav.work_tools-webhooks" },
          { path: `${APP_PREFIX_PATH}/work-tools/invoicexpress`, title: "sidenav.work_tools-invoicexpress" },
          { path: `${APP_PREFIX_PATH}/work-tools/moloni`, title: "sidenav.work_tools-moloni" },
          { path: `${APP_PREFIX_PATH}/work-tools/bill`, title: "sidenav.work_tools-bill" },
          { path: `${APP_PREFIX_PATH}/work-tools/systeme-io`, title: "sidenav.work_tools-systeme-io" },
          { path: `${APP_PREFIX_PATH}/work-tools/mailerlite`, title: "sidenav.work_tools-mailerlite" },
          { path: `${APP_PREFIX_PATH}/work-tools/cofidispay`, title: "sidenav.work_tools-cofidispay" },
          { path: `${APP_PREFIX_PATH}/work-tools/shorteners`, title: "sidenav.work_tools-shorteners" },
        ],
        title: "Ferramentas",
        description: "Ferramentas e Integrações com a SalesPark (pixels, faturação, email marketing, etc).",
        tags: [
          "ferramenta",
          "integração",
          "integrações",
          "pixel",
          "faturação",
          "email",
          "marketing",
          "zapier",
          "api",
          "mailerlite",
          "systeme.io",
          "invoiceXpress",
          "moloni",
          "shorteners",
          "webhooks",
          "contabilidade",
        ],

        icon: ToolOutlined,
        breadcrumb: true,
        submenu: [],
      },

      {
        key: "salespark-support-request",
        scope: ["base"],
        path: `${APP_PREFIX_PATH}/support-request`,
        title: "Pedido de Suporte",
        description: "Enviar pedido de suporte para a SalesPark.",
        tags: ["suporte", "pedido", "ajuda", "assistência", "problema", "erro", "suporte técnico"],
        icon: NotificationOutlined,
        breadcrumb: true,
        new_tab: true,
        submenu: [],
      },
      {
        key: "salespark-feedback",
        scope: ["base"],
        path: `${APP_PREFIX_PATH}/feedback`,
        title: "Feedback & Sugestões",
        description: "Enviar feedback e sugestões de melhoria da plataforma SalesPark.",
        tags: ["feedback", "sugestão", "melhoria", "plataforma", "sugestão", "opinião"],
        icon: RocketOutlined,
        breadcrumb: true,
        new_tab: true,
        submenu: [],
      },
      {
        key: "salespark-help",
        scope: ["base"],
        path: `${APP_PREFIX_PATH}/help`,
        title: "Central de Ajuda",
        description: "Central de ajuda e tutoriais para te ajudar a usar a SalesPark.",
        tags: ["ajuda", "tutorial", "video", "suporte", "ajuda", "começar"],
        icon: QuestionCircleOutlined,
        breadcrumb: true,
        new_tab: true,
        submenu: [],
      },
    ],
  },
];

let navigationConfig;
// if (host === "localhost" || host === "beta-app.salespark.io" || host === "app.salespark.io") {
navigationConfig = [...defaultNavTree];

// }

// if (host === "wa-buddy.localhost" || host === "beta-wa-buddy.salespark.io" || host === "wa-buddy.salespark.io") {
//   navigationConfig = [...waBuddyNavTree];
// }

/** Alternate trees for host-based routing (kept for future use). */
export { waBuddyNavTree };

export default navigationConfig;
